import { isHandoffEvent } from 'components/responses/utils/messages';
import Robot from 'img/robot.svg';
import UserIcon from '../components/UserIcon';
import {
  isSubscriberActivityEvent,
  SYSTEM_EVENT_SALES_AI_SUBSTRING,
  ViewOptions,
  VIEW_OPTIONS,
} from '../constants';
import { Message } from '../types';

export const canViewSystemMessage = (
  message: Partial<Message>,
  view: ViewOptions,
): boolean => {
  if (view === VIEW_OPTIONS.AI_DEBUGGER) return true;
  if (view === VIEW_OPTIONS.MERCHANT) {
    // Merchants see handoffs and the subscriber's own activity, but not the
    // internal AI and support-routing chatter every other system event
    // carries.
    return isHandoffEvent(message) || isSubscriberActivityEvent(message);
  }

  return (
    view === VIEW_OPTIONS.SALES_ASSOCIATE &&
    !message?.type?.includes(SYSTEM_EVENT_SALES_AI_SUBSTRING)
  );
};

interface GetAvatarInput {
  message: Message;
  shopName?: string;
  currentView: ViewOptions;
  id: string;
}

export const getUserAvatar = ({
  message,
  currentView,
  shopName,
  id,
}: GetAvatarInput): JSX.Element => {
  if (message.user_first_name && message.user_last_name) {
    return (
      <UserIcon
        color="var(--color-message-text-outbound)"
        title={`${message.user_first_name} ${message.user_last_name}`}
        display={`${message.user_first_name[0]}${message.user_last_name}`}
        backgroundColor="var(--color-message-bubble-outbound)"
        image={message.user_avatar_url}
        id={id}
      />
    );
  }

  const avatarImage =
    (
      [VIEW_OPTIONS.AI_DEBUGGER, VIEW_OPTIONS.SALES_ASSOCIATE] as string[]
    ).includes(currentView) && message.is_sent_by_salesbub
      ? Robot
      : undefined;
  return (
    <UserIcon
      title={shopName}
      display={shopName?.[0].toUpperCase()}
      color="var(--color-message-text-system)"
      backgroundColor="var(--color-message-bubble-system)"
      image={avatarImage}
      id={id}
      isShop
    />
  );
};
